import React, { useMemo } from "react";

import { ProductTileModel } from "@api/mappers/products.mapper";

import { CartModel } from "@redux/modules/api/data/cart/@types/cart.model";
import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { BundleProductComponent } from "@components/Product/ProductBundles/BundleProduct/bundleProduct.component";
import { ProductBundleAddToCartButtonComponent } from "@components/Product/ProductBundles/ProductBundleAddToCartButton/productBundleAddToCartButton.component";
import { ProductBundlePrice } from "@components/Product/ProductBundles/ProductBundlePrice/productBundlePrice.container";
import { ProductTileLayout } from "@components/Product/ProductTile/productTile.config";
import { ProductTile } from "@components/Product/ProductTile/productTile.container";

import "../productBundles.scss";

type ProductBundleComponentProps = {
    mainProduct: ProductTileModel;
    bundleProducts: Array<ProductTileModel>;
    cart?: CartModel;
    onAddToCart: () => void;
    addToCartLoading: boolean;
};

const ProductBundleComponent = ({
    mainProduct,
    bundleProducts,
    cart,
    onAddToCart,
    addToCartLoading,
}: ProductBundleComponentProps) => {
    const { t } = useGranite();

    const bundleProductSkus = useMemo(
        () => bundleProducts.map(bundleProduct => bundleProduct.sku),
        [bundleProducts],
    );

    return (
        <section className={"productBundle__bundle"}>
            <div className={"m-3 d-flex"}>
                <ProductTile
                    className={"flex-grow-1 w-100"}
                    sku={mainProduct.sku}
                    product={mainProduct}
                    allowInstantAddToCart={false}
                    productTileConfig={{
                        amountOfFeatures: 0,
                        components: ProductTileLayout.BUNDLE(),
                    }}
                />
                {bundleProducts.map(bundleProduct => (
                    <BundleProductComponent
                        key={bundleProduct.sku}
                        bundleProduct={bundleProduct}
                    />
                ))}
            </div>
            <div
                className={
                    "productBundle__buy px-3 py-2 d-flex justify-content-end align-items-center"
                }
            >
                <p className={"mb-0 flex-grow-1 text-left"}>
                    {t("general.productBundles.combinationPrice")}
                </p>
                <ProductBundlePrice
                    className={"mr-3"}
                    mainProduct={mainProduct}
                    bundleProducts={bundleProducts}
                />
                <ProductBundleAddToCartButtonComponent
                    cart={cart}
                    onAddToCart={onAddToCart}
                    addToCartLoading={addToCartLoading}
                    bundleSkus={[mainProduct.sku, ...bundleProductSkus]}
                />
            </div>
        </section>
    );
};

export { ProductBundleComponent };
